<mat-dialog-content>
  <h2 class="dialog-title-no-padding" mat-dialog-title>Duplicate "{{ data.template?.name }}"</h2>

  <p class="text-opacity-low">
    The current template will stay active until the day before the start date.
    The duplicate will be active from the start date through the end date.
  </p>

  <form [formGroup]="form" class="d-flex flex-column gap-2">
    <mat-form-field appearance="outline">
      <mat-label>New template name</mat-label>
      <input matInput formControlName="name">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Start date</mat-label>
      <input matInput readonly [matDatepicker]="startPicker" formControlName="splitDate" (click)="startPicker.open()">
      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>End date</mat-label>
      <input matInput readonly [matDatepicker]="endPicker" formControlName="dateTo" (click)="endPicker.open()">
      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>

    <p *ngIf="error" class="error-text-color">{{ error }}</p>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" [disabled]="saving" (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" type="button" [disabled]="!form.valid || saving" (click)="save()">
    {{ saving ? 'Duplicating…' : 'Duplicate' }}
  </button>
</mat-dialog-actions>
